import { Box, makeStyles, createStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Meter } from '../../../../components/ssm/ssm.types';
import { useTranslation } from '../../../../hooks/useTranslation';
import colors from '../../../../themes/main-colors';

interface Props {
  meter: Meter;
  index: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    meter: {
      width: '100%',
      marginBottom: '15px',
      '& > p': {
        fontSize: '14px',
      },
    },
    textColor: {
      color: colors.noirBlur,
    },
  }),
);

export const SelectedMetersList = (props: Props) => {
  const { meter, index } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      <Box className={classes.meter}>
        <Typography data-testid="meter-index">{`${t(
          'METER',
        ).toUpperCase()} ${index + 1}`}</Typography>
        <Typography data-testid="meter-type">
          {t('TYPE')}
          {': '}
          <b className={classes.textColor}>{meter.spDesc}</b>
        </Typography>
        {meter.locationDesc ? (
          <Typography data-testid="meter-location">
            {t('LOCATION')}
            {': '}
            <b className={classes.textColor}>{meter.locationDesc}</b>
          </Typography>
        ) : meter.meterNumber ? (
          <Typography data-testid="meter-number">
            {t('METER_NO')}
            {': '}
            <b className={classes.textColor}>{meter.meterNumber}</b>
          </Typography>
        ) : null}
      </Box>
    </>
  );
};
